import { render, staticRenderFns } from "./AiChatWidget.vue?vue&type=template&id=70c84fc4&scoped=true"
import script from "./AiChatWidget.vue?vue&type=script&lang=js"
export * from "./AiChatWidget.vue?vue&type=script&lang=js"
import style0 from "./AiChatWidget.vue?vue&type=style&index=0&id=70c84fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c84fc4",
  null
  
)

export default component.exports